"use client";

import { FaChevronLeft } from "react-icons/fa";
import { Reply, Trash2 } from "lucide-react";
import { Button } from "@/shadcn-components/ui/button";
import {
  type MailRow,
  DirectionIcon,
  SeverityMark,
  displayParty,
  listPartyLabel,
} from "@/vybe-trader-client/mailbox/mailboxView";

interface MailDetailScreenProps {
  onBack: () => void;
  mail: MailRow;
  onDelete: () => void;
  onReply: () => void;
}

export default function MailDetailScreen({
  onBack,
  mail,
  onDelete,
  onReply,
}: MailDetailScreenProps) {
  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <div className="flex shrink-0 items-center gap-2 border-b border-border px-3 py-2">
        <Button variant="ghost" size="icon" onClick={onBack} className="h-8 w-8 shrink-0">
          <FaChevronLeft className="h-4 w-4 text-blue-400" />
        </Button>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold">{mail.subject}</p>
          <p className="flex items-center gap-1 truncate text-[11px] text-muted-foreground">
            <DirectionIcon isSent={mail.isSent} className="h-3 w-3" />
            <span>{listPartyLabel(mail)}</span>
            <SeverityMark severity={mail.severity} />
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0"
          onClick={onReply}
          title="Reply"
        >
          <Reply className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0 text-destructive hover:text-destructive"
          onClick={onDelete}
          title="Remove"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>

      <div className="shrink-0 border-b border-border px-3 py-2 text-[11px] text-muted-foreground">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span>
            {mail.isSent ? "To" : "From"}:{" "}
            <span className="text-foreground">
              {mail.isSent ? displayParty(mail.to) : displayParty(mail.from)}
            </span>
          </span>
          <span>
            {mail.date} · {mail.time}
          </span>
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-3 py-4">
        <p className="whitespace-pre-wrap text-sm leading-relaxed text-foreground/90">
          {mail.body}
        </p>
      </div>

      <div className="shrink-0 border-t border-border p-3">
        <Button className="w-full" size="sm" onClick={onReply}>
          <Reply className="mr-2 h-4 w-4" />
          Reply
        </Button>
      </div>
    </div>
  );
}
